import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconCodigoBarraBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function PickingMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.PICKING, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 95,
      content: { menu: '4.1 - Áreas de Separação', path: '/main/picking/area-separacao' },
    },
    {
      id: 96,
      content: { menu: '4.2 - Equipe de Separação', path: '/main/picking/equipe-separacao' },
    },
    {
      id: 97,
      content: { menu: '4.3 - Picking - Código de Barra', path: '/main/picking/codigo-barra' },
    },
    {
      id: 98,
      content: { menu: '4.4 - Picking - Manual', path: '/main/picking/manual' },
    },
    {
      id: 99,
      content: {
        menu: '4.5 - Cadastro de Ocorrências de Produto',
        path: '/main/picking/ocorrencia-empresa',
      },
    },
    {
      id: 100,
      content: {
        menu: '4.6 - Cargas Pendentes Para Picking',
        path: '/main/picking/cargas-pendentes-para-picking',
      },
    },
    {
      id: 101,
      content: {
        menu: '4.7 - Histórico de Leitura por Período Por Lote',
        path: '/main/picking/historico-leitura-periodo-lote',
      },
    },
    {
      id: 102,
      content: { menu: '4.8 - Picking - Reconferência', path: '/main/picking/reconferencia' },
    },
    {
      id: 134,
      content: {
        menu: '4.9 - Re-conferência - Etiqueta',
        path: '/main/picking/reconferencia-etiqueta',
      },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconCodigoBarraBlue} alt="Icon Tela de Picking" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>4. Picking</span>
      </PageMenu>
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(PickingMenu))
